<template>
  <div class="footer" v-if="this.$route.path!='/printTransportTicket'">
    <div class="footer-content">
      <div class="footer-left" @click="$router.push('/')">
        <img class="logo" src="@/assets/img/logo.png" alt="" />
      </div>
      <div class="footer-right">
        <div
          class="footer-menu"
          v-for="(item, i) in menu"
          :key="i"
          @click="jump(item.path)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="footer-bottom">京 ICP 备 123456789号</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      list: [
        { path: "/home", name: "首页" },
        { path: "/driver", name: "司机中心", role: "DRIVER" },
        { path: "/consignor", name: "货主中心", role: "CUSTOMER" },
        { path: "/carriers", name: "承运商中心", role: "CARRIERS" },
        { path: "/business", name: "业务中心" },
        { path: "/help", name: "帮助中心" },
      ],
      menu: [],
    };
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  watch: {
    isLogin(val) {
      this.setMenu();
    },
  },
  methods: {
    jump(path, i) {
      this.index = i;
      this.$router.push(path);
    },
    setMenu() {
      this.menu = [];
      if (this.isLogin) {
        const role = JSON.parse(localStorage.getItem("userInfo")).currentRole;
        this.list.map((item) => {
          if (!item.role || item.role == role) {
            this.menu.push(item);
          }
        });
      } else {
        this.menu = this.list;
      }
    },
  },
  created() {},
  mounted() {
    this.setMenu();
  },
};
</script>
<style scoped lang="less">
.footer {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  height: 200px;
  width: 100%;
  background-color: #263238;
  color: #fff;
  .footer-content {
    margin: 60px auto;
    width: 1200px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .footer-left {
      display: flex;
      align-items: center;
      .logo {
        width: 200px;
      }
      .logo-title {
        margin-left: 10px;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .footer-right {
    margin-left: 100px;
    display: flex;
    // justify-content: flex-end;
    .footer-menu {
      cursor: pointer;
      padding: 5px 20px;
    }
    .footer-menu:hover {
      color: #337df8;
    }
  }
  .footer-bottom {
    font-size: 13px;
    text-align: center;
  }
}
</style>
